angular.module('SpidApp')

.factory('StockChartUtils', [function () {
    return {
        sum: function (arr) {
            return arr.reduce(function(memo, value) {
              return memo + value;
            }, 0);
        },
        
        cut: function (arr, n) {
            return arr.slice(0, n)
        },
        
        continuousDistribution: function (data) {
            var res = []
            var previous = 0
            
            for(var i = 0 ; i < data.length ; i++) {
                res[i] = data[i] || previous
                if (data[i] !== null) {
                    previous = data[i]
                }
            }
            
            return res
        },
        
        cumulativeDistribution: function (data) {
            var res = []
            
            for(var i = 0 ; i < data.length ; i++) {
                res[i] = data[i] + this.sum( this.cut(data, i) )
            }
            
            return res
        },
        
        _getHash: function(str){
    	  var hash = 5381;
    	  for (var i = 0; i < str.length; i++) {
    	    hash = ((hash << 5) + hash) + str.charCodeAt(i); /* hash * 33 + c */
    	  }
    	  return hash;
    	},

    	hashStringToColor: function(str) {
    	  var hash = this._getHash(str);
    	  var r = (hash & 0xFF0000) >> 16;
    	  var g = (hash & 0x00FF00) >> 8;
    	  var b = hash & 0x0000FF;
    	  return "#" + ("0" + r.toString(16)).substr(-2) + ("0" + g.toString(16)).substr(-2) + ("0" + b.toString(16)).substr(-2);
    	}
    }
}])
